import { useState, useEffect } from 'react';
import {collection, query, where, getDocs, doc, deleteDoc, updateDoc, arrayUnion, arrayRemove, addDoc} from "firebase/firestore";
import { db } from '../firebaseInit';
import { v4 as uuidv4 } from 'uuid';
import {decodeLoggedAt, toDateTime} from "../utils/utils";
import useLocalState from "./useLocalState";


const useDemoExpenses = (accountId) => {
    const [expenses, setExpenses] = useLocalState('expenses', []);
    const [currentExpense, setCurrentExpense] = useLocalState('currentExpense', null)

    const selectExpense = (expense) => {
        setCurrentExpense(expense)
        console.log('useUpdateExpenseSidebar:selectExpense:', expense)
    }

    const save = async ({costInCents, loggedAt}) => {
        setExpenses(expenses.map(expense => {
            if (expense.id === currentExpense.id) {
                const entryToDelete = expense.entries.find(entry => {
                    const loggedAtDate = toDateTime(decodeLoggedAt(entry.loggedAt))
                    const loggedAtMonth = loggedAtDate.getMonth()
                    const loggedAtYear = loggedAtDate.getFullYear()

                    const newLoggedAtMonth = loggedAt.getMonth()
                    const newLoggedAtYear = loggedAt.getFullYear()
                    console.log('useExpenses:save:entryToDelete:', loggedAtDate, loggedAtMonth, loggedAtYear, newLoggedAtMonth, newLoggedAtYear)

                    return loggedAtMonth === newLoggedAtMonth && loggedAtYear === newLoggedAtYear
                })
                const newEntry = {
                    uuid: uuidv4(),
                    costInCents,
                    loggedAt: new Date(loggedAt)
                }
                const newEntries = [...expense.entries.filter(entry => entry.uuid !== entryToDelete?.uuid), newEntry]
                return {
                    ...expense,
                    entries: newEntries
                }
            }
            return expense
        }))
        setCurrentExpense(null)
    }

    const removeEntry = async ({expenseId, uuid}) => {
        setExpenses(expenses.map(expense => {
            if (expense.id === expenseId) {
                return {
                    ...expense,
                    entries: expense.entries.filter(entry => entry.uuid !== uuid)
                }
            }
            return expense
        }))
    }

    const deleteExpense = async (expenseId) => {
        setCurrentExpense(null)
        setExpenses(expenses.filter(expense => expense.id !== expenseId))
    }

    const addExpense = async ({newExpenseName, newExpenseCost, loggedAt, expenseType}) => {
        const newExpense = {
            id: uuidv4(),
            userId: accountId,
            name: newExpenseName,
            expenseType,
            entries: [{
                uuid: uuidv4(),
                costInCents: newExpenseCost*100,
                loggedAt: loggedAt
            }]
        }
        setExpenses([...expenses, newExpense])
        return newExpense
    }

    return { expenses, currentExpense, controls: {selectExpense, save, deleteExpense, addExpense, removeEntry} };
};

export default useDemoExpenses;
